(function($){
  const STOREFRONT_PUBLIC_TOKEN = "9dac7017f7c94d6624d4ae05c1fb857b";
  const SHOPIFY_STORE_DOMAIN = "xcvi.myshopify.com";
  
  var productHandleAjax = null;
  var xcviSwatchProducts = [];
  var swatchVariants = [];
  var swatchVarKeyArr = {};
  
  function fetchProductUsingGraphQl($handle)
  {
    $.ajax({
      method: "POST",
      async: false,
      url: `https://${SHOPIFY_STORE_DOMAIN}/api/2024-01/graphql`,
      contentType: "application/json",
      headers: {
        'X-Shopify-Storefront-Access-Token': STOREFRONT_PUBLIC_TOKEN
      },
      data: JSON.stringify({
        query: `query ($handle: String!) {
                productByHandle(handle: $handle) {
                  variants(first: 100) {
                      nodes {
                          id
                          metafield(namespace: "custom", key: "presale_date") {
                              key
                              value
                          }
                          availableForSale
                          currentlyNotInStock
                          selectedOptions {
                              name
                              value
                          }
                      }
                  }
                  id
                  handle
                  options(first: 100) {
                      name
                      values
                  }
              }
            }`,
        variables: { "handle": $handle },
      }),
      complete: function(data) {
        productHandleAjax = null;
        // console.log(data);
        return data;
      },
      success: function (response) {
        console.log(response);
        if (response.data.productByHandle) {
          xcviSwatchProducts.push(parseProductResponse(response));
        }
      },
      error: function(data) {
        return data;
      }
    });
  }

  function parseProductResponse(response)
  {
    let product = response.data.productByHandle;
    return product;
  }

  function fetchSwatchColorStyle(color)
  {
    let items = color_config.filter(item => item.name == color);
    if (items.length != 0) {
      let c = items[0];
      var style = 'style="';
      if (c.value.startsWith("#")) {
        style += `--swatch-background:${c.value}`;
      }else{
        style += `--swatch-background:url(${c.value})`;
      }
      style += '"';
      return style;
    }
    return false;
  }

  function defaultProductColors(mainProductOnly = true)
  {
    if (mainProductOnly) {
      return array_unique(swatchVariants.filter(item => (item.external == false)).map(item => item.color));
    }else{
      return array_unique(swatchVariants.map(item => item.color));
    }
  }

  function swatch_core_colors(colors)
  {
    return colors.filter(function(n) {
      return core_colors.indexOf(n) > -1;
    });
  }

  function swatch_other_colors(colors)
  {
    return colors.filter(function(n) {
      return core_colors.indexOf(n) == -1;
    });
  }

  function is_core_color(color)
  {
    return core_colors.indexOf(color) > -1;
  }

  function is_other_color(color)
  {
    return core_colors.indexOf(color) == -1;
  }

  function array_values(data) {
    var tempObj = [];
    Object.keys(data).forEach((prop) => {
      if (data[prop]) { tempObj.push(data[prop]); }
    });
    return tempObj;
  }

  function array_unique(data){
    return [...new Set(data)];
  }
  
  function fetchProductData(product)
  {
    let variants = product.variants.nodes;
    variants.forEach(function(variant, index){
      let swatch = {};
      swatch.available = variant.availableForSale;
      swatch.p_id = product.id.split('/').pop();
      swatch.id = variant.id.split('/').pop();
      swatch.external = false;
      let options = variant.selectedOptions;
      options.forEach(function(option){
        if (option.name.toLowerCase() == 'size') {
          swatch.size = option.value;
        }
        if (option.name.toLowerCase() == 'color') {
          swatch.color = option.value;
        }
      });
      swatchVarKeyArr[swatch.id] = swatch;
    });
    swatchVariants = array_values(swatchVarKeyArr);
  }
  let xcviProductHandle = null;
  let xcviProductSwatches = null;
  let xcviShouldSplitSwatches = false;
  
  $( document ).ready(function() {
      console.log( "ready!" );
      let colorFieldset = $('.swatch-color-fieldset');
      xcviProductSwatches = colorFieldset.data('product-swatches');
      xcviShouldSplitSwatches = colorFieldset.data('split-swatch');
      xcviProductHandle = colorFieldset.data('product-handle');
      console.log(xcviProductSwatches, xcviShouldSplitSwatches);
      if(typeof xcviProductSwatches !== 'undefined' && xcviProductSwatches && xcviProductSwatches.length != 0){
        for(i = 0; i< xcviProductSwatches.length; i++)
        {
          let handle = xcviProductSwatches[i];
          fetchProductUsingGraphQl(handle);
        }
        fetchProductColorData();
        renderProductColorSwatch();
      }
  });

  function fetchProductColorData()
  {
    xcviSwatchProducts.forEach(function(product, index){
      let variants = product.variants.nodes || [];
      let options = product.options;
      options.forEach(function(option){
        if (option.name.toLowerCase() == 'color') {
          product.color = option.values[0];
          product.is_core_color = is_core_color(product.color);
          product.color_style = fetchSwatchColorStyle(product.color);
        }
      });
      product.p_id = product.id.split('/').pop();
      if(variants.length != 0){
        variants.forEach(function(variant){
          let options = variant.selectedOptions;
          options.forEach(function(option){
            if (option.name.toLowerCase() == 'size') {
              variant.size = option.value.toLowerCase();
            }
          });
          variant.available = variant.availableForSale;
          variant.v_id = variant.id.split('/').pop();
          if(variant.available == true){
            variant.li_data_attr = `data-szav-standard-${variant.size}="1"`;
          }else{
            variant.li_data_attr = `data-szav-standard-${variant.size}="0"`;
          }
          variant.link_data_attr = `data-variant-standard-${variant.size}="${variant.v_id}"`;
        });
      }
      product.variants = variants;
    });
  }

  function renderProductColorSwatch()
  {
    var c_color_products = xcviSwatchProducts.filter(item => (item.is_core_color == true));
    var s_color_products = xcviSwatchProducts.filter(item => (item.is_core_color == false));
    var size_element = '';
    $('.xcvi-color-swatch-item-js').remove();
    if (xcviShouldSplitSwatches == true || xcviShouldSplitSwatches == "true") {
      let c_selected_color = c_color_products.filter(item => item.handle == xcviProductHandle).map(item => item.color);
      size_element = renderColorHTML(c_color_products, 'Core Colors', c_selected_color);
      $('.swatch-color-fieldset .variant-picker__option-values.core_color_list').append(size_element);
      let s_selected_color = s_color_products.filter(item => item.handle == xcviProductHandle).map(item => item.color);
      size_element = renderColorHTML(s_color_products, 'Seasonal Colors', s_selected_color);
      $('.swatch-color-fieldset .variant-picker__option-values.fashion_color_list').append(size_element);
    } else {
      size_element = renderColorHTML(xcviSwatchProducts);
      $('.swatch-color-fieldset .variant-picker__option-values.normal_color_list').append(size_element);
    }
  }

  function renderColorHTML(products, title = 'Color', selectedColor = '')
  {
    var html = '';
    if (products.length != 0) {
      products.forEach(function(product){
        if (product.color_style) {
          html += color_item_html(product);
        }
      });
    }
    return html;
  }

  function color_item_html(product)
  {
    let li_data_attrs = product.variants.map(item => item.li_data_attr).join(' ');
    let link_data_attrs = product.variants.map(item => item.link_data_attr).join(' ');
    let size_variants = product.variants.map(item => `${item.size}:${item.v_id}`).join(',');
    let li_class = '';
    if(product.handle == xcviProductHandle){
      li_class = 'selected--option';
    }

    return `<input class="sr-only swatch-item-color" type="radio" data-href="/products/${product.handle}" name="product-form-main-color" id="product-option-id-${product.p_id}" value="" ${li_data_attrs} ${link_data_attrs} data-variants="${size_variants}">
            <label class="color-swatch product-custom-swatch" for="product-option-id-${product.p_id}" ${product.color_style}>
              <span class="sr-only">${product.color}</span>
            </label>`;
  }

})(jQuery);